import { Route, Routes, useParams } from 'react-router-dom';
import Page404 from "./pages/404";
import Home from "./pages/home";
import Profile from './pages/profile';
import Following from './pages/following';
import History from './pages/history';
import Nft from './pages/nft';
import Settings from './pages/settings';
import Chime from './pages/chime';
import Muted from './pages/muted';
import Extensions from './pages/extensions';
import MineRewads from './pages/mining';
import StackRewards from './pages/stacking';
import TokenLaunchPad from './pages/launchpad/TokenLaunchPad';
import LandingScreen from './pages/landingPage/LandingScreen';
import { userSession } from './services/auth';
import Game from './pages/game/Game';

const isAuthenticated = userSession.isUserSignedIn();

const AllRoutes = ({ setReplyOpen, userSettings, setUserSettings }) => (
  <Routes>
    {isAuthenticated ? (
      <>
        <Route path='/' element={<Home setReplyOpen={setReplyOpen} userSettings={userSettings} />} />
        <Route path='mining' element={<MineRewads userSettings={userSettings} />} />
        <Route path='stacking' element={<StackRewards userSettings={userSettings} />} />
        <Route path='following' element={<Following userSettings={userSettings} />} />
        <Route path='muted' element={<Muted />} />
        <Route path='extensions' element={<Extensions />} />
        <Route path='game' element={<Game />} />
        <Route path='settings' element={<Settings userSettings={userSettings} setUserSettings={setUserSettings} />} />
        <Route path='history' element={<History userSettings={userSettings} />} />
        <Route path='launch' element={<TokenLaunchPad userSettings={userSettings} />} />
        <Route path='nft/:contractId/:nftId' element={<Nft userSettings={userSettings} />} />
        <Route path='/:param/*' element={<DynamicRoute userSettings={userSettings} />} />
      </>
    ) : (
      <>
        <Route path='/' element={<LandingScreen />} />
        <Route path='*' element={<LandingScreen />} />
      </>
    )}
    <Route path='/*' element={<Page404 />} /> {/* Handle 404 */}
  </Routes>
);

const DynamicRoute = ({ userSettings }) => {
  const { param } = useParams();
  const address = (param.startsWith('SP') || param.startsWith('ST') || param.includes('.')) ? param : null;

  if (address) {
    return <Profile address={address} userSettings={userSettings} />;
  }

  else if (param.startsWith('0x')) {
    return <Chime txId={param} userSettings={userSettings} />;
  }

  else {
    return <Page404 />;
  }
};

export default AllRoutes;
